<script lang="ts">
    import cn from 'classnames';

    import { globalStore } from '@components/stores';
    import { Font, FontTypes } from '@uikit/font';

    import { Toast } from './components/toast';
    import { toastsStore } from './store';

    import s from './toasts.module.css';

    $: items = Array.from($toastsStore.toasts.entries()) ?? [];

    const closeItem = (key: symbol) => {
        toastsStore.removeByIndex(key);
    };

    $: isDesktop = $globalStore.isDesktopSite;
</script>

<div class={cn(s.root, { [s.desktop]: isDesktop })}>
    {#each items as [symbol, toast] (symbol)}
        <Toast
            {symbol}
            classes={cn(s.item)}
            type={toast.type}
            {isDesktop}
            persistence={toast.params.persistence}
            on:close={() => closeItem(symbol)}
        >
            <Font type={FontTypes.Type.body} tagName={FontTypes.TagName.span}>
                {#if typeof toast.message === 'string'}
                    {@html toast.message}
                {:else}
                    <svelte:component this={toast.message} />
                {/if}
            </Font>
        </Toast>
    {/each}
</div>
